<template>
  	<div class="stores">
    	<div class="breadcrumb">会员管理 > AI会员列表</div>
	    <div class="searchBtn" style="border:none;display:flex">
			<el-button size='small' type="primary" icon="el-icon-plus" @click="add" plain>添加</el-button>
			<div class="topinput">
				<input type="text" placeholder="请输入手机号" class="el-input__inner" v-model="mobile"  @keyup.enter="search_mine"/>
			</div>
	      	<el-date-picker
	      		v-model="timeVal"
	      		type="daterange"
	      		range-separator=" 至 "
	      		start-placeholder="开始日期"
	      		end-placeholder="结束日期"
      			value-format="yyyy-MM-dd">
	    	</el-date-picker>
	    	<el-button type="primary" @click="search_mine" style="margin-left:15px">搜索</el-button>
	    </div>
	    <!-- 列表 -->
    	<div class="main">
      		<template>
        		<el-table ref="multipleTable" :data="tableData" highlight-current-row tooltip-effect="dark" style="width: 100%">
		          	<el-table-column prop="mobile" label="手机号"></el-table-column>
		          	<el-table-column prop="rechargeDesc" label="充值备注"></el-table-column>
		          	<el-table-column prop="beginDate" :formatter="this.global.dateFormat" label="开始时间"></el-table-column>
					<el-table-column prop="endDate" :formatter="this.global.dateFormat" label="结束时间"></el-table-column>
		          	<el-table-column prop="createTime" :formatter="this.global.dateFormat" label="创建时间"></el-table-column>
        		</el-table>
      		</template>
	      	<div class="block" style="padding:30px 10px; float:right">
	        	<el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
	      	</div>
    	</div>
    	<!-- 弹框 -->
    	<el-dialog title="提示" :visible.sync="dialogVisible" width="35%" :before-close="handleClose">
	      	<el-form :model="ruleForm" ref="ruleForm" :rules="ruleForms" status-icon label-width="80px">
	      		<input type="hidden" v-model="ruleForm.mobiles" >
	        	<el-form-item label="手机号" prop="tel">
	          		<el-input type="textarea" :rows="5" v-model="ruleForm.tel" placeholder="请输入手机号，多个手机号“英文”状态下逗号 “ , ” 隔开" style="width:80%"></el-input>
	        	</el-form-item>
				<el-form-item label="充值数量" prop="rechargeNum">
	          		<el-input v-model="ruleForm.rechargeNum" placeholder="请输入充值数量" style="width:80%"></el-input>
	        	</el-form-item>
	        	<el-form-item label="充值类型" prop="rechargeType">
				    <el-radio-group v-model="ruleForm.rechargeType">
				      	<el-radio :label="0">日</el-radio>
				      	<el-radio :label="1">月</el-radio>
				      	<el-radio :label="2">年</el-radio>
				    </el-radio-group>
			  	</el-form-item>
		        <el-form-item label="充值备注">
		          	<el-input type="textarea" v-model="ruleForm.rechargeDesc" placeholder="请输入充值备注" style="width:80%" :rows="5"></el-input>
		        </el-form-item>
		        <input type="hidden" v-model="ruleForm.uuid" />
	      	</el-form>
	      	<span slot="footer" class="dialog-footer">
		        <el-button @click="dialogVisible = false">取 消</el-button>
		        <el-button type="primary" @click="onSubmit('ruleForm')">确 定</el-button>
	      	</span>
    	</el-dialog>
  	</div>
</template>

<script>
export default {
  	components: {},
	mounted() {
	    this.init();
	},
  	data() {
    	return {
      		tableData: [],
      		pageNum: 0,
      		limit: 10,
      		totalPage: 10,
      		ruleForm: {
      		},
      		ruleForms: {
		        tel: [{ required: true, message: "请输入手机号", trigger: "blur" }],
		        rechargeNum: [{ required: true, message: "请输入充值数量", trigger: "blur" }],
		        rechargeType: [{ required: true, message: '请选择充值类型', trigger: 'change' }]
      		},
		    dialogVisible: false,
		    timeVal:'',
		    mobile:'',
    	};
  	},
  	methods: {
	    //初始化表格数据
	    init() { 
	      	let params = {
	      		pageNum:this.pageNum,
	      		limit:this.limit,
	      		mobile:this.mobile,
	      		vipRechargeStartTime:this.timeVal?this.timeVal[0].valueOf():'',
	      		vipRechargeEndTime:this.timeVal?this.timeVal[1].valueOf():''
	      	}
	      	this.$get("/users/getAiVipRechargeRecord", params)
	        .then(res => {
	        	console.log(res)
	          	if (res.code == 0) {
		            this.tableData = res.data.list;
		            this.totalPage = res.data.total;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
		        }
	        })
	    },
	    search_mine(){
	    	this.pageNum=1;
	    	this.init();
	    },
	    //当前页数
	    handleCurrentChangePage(val) {
	      	this.searchForm.pageNum = val;
	      	this.init();
	    },
	    //弹框关闭按钮
	    handleClose(done) {
	      	if (this.$refs.ruleForm != undefined) {
	        	this.$refs.ruleForm.resetFields();
	      	}
	      	done();
	    },
	    add(row) {
	    	this.$refs.multipleTable.setCurrentRow(row);
	      	if (this.$refs["ruleForm"]) {
	        	this.$refs["ruleForm"].resetFields();
	      	}
	      	this.dialogVisible = true;
	    },
	    randomString(len){
	    	len = len || 16;
		　　var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz1234567890';
		　　var maxPos = $chars.length;
		　　var pwd = '';
		　　for (var i = 0; i < len; i++) {
		　　　　pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
		　　}
		　　return pwd;
	    },
	    onSubmit(formName) {
	    	this.ruleForm.uuid=this.randomString(16);
	      	this.$refs[formName].validate((valid) => {
	          	if (valid) {
	          		var tel = this.ruleForm.tel,ss;
	          		ss=tel.split(",")
					this.ruleForm.mobiles = ss ;
			    	console.log(this.ruleForm)
	            	this.$post("/users/addAIVipTimes", JSON.stringify(this.ruleForm))
	              	.then(res => {
	             		var str='';
	             		if(res.code==0){                  		
	                  		this.$refs.ruleForm.resetFields();
	                  		this.pageNum = 1;
	                  		this.init();
	                  		this.dialogVisible = false;
	             			if(res.data.length>0){
	             				for(var i=0;i<res.data.length;i++){
	             					str+='<p style="margin-bottom:5px">'+res.data[i]+'</p>'
	             				}
	             				this.$alert(str, '以下手机号充值失败', {
						          	dangerouslyUseHTMLString: true
						        });
	             			}else{
		             			this.$message({
		                    		message: '充值成功',
		                    		type: "success"
		                  		});	
		             		}
	             		}
	              	})
	          	} else {
	            	console.log('error submit!!');
	            	return false;
	          	}
	        });
	    },
  	}
};
</script>

<style scoped>
.topinput{
	position: relative;
	margin: 0 15px;
	width: 250px
}
.topinput input{
	font-size: 13px;
}
::deep
.el-date-editor .el-range-separator{
	padding: 0
}
</style>



// WEBPACK FOOTER //
// src/views/memberManagement/aiMembers.vue